import { useMemo, useState } from "react";
import { AccountData, TeamMember, TeamMemberRole } from "@markit/common.types";
import { Colors } from "../../utils/colors";
import ProfileItem from "../ProfileItem";
import LabelButton from "../Buttons/LabelButton";
import ThreeDotsButton from "../Buttons/ThreeDotsButton";
import { useSelector } from "react-redux";
import { getAccountState } from "../../redux/slices/accountSlice";
import ManageTeamMemberDropdown from "../CreatorDashboard/TeamMembers/ManageTeamMemberDropdown";

type TeamMemberItemProps = {
  item: AccountData;
  teamMember: TeamMember | undefined;
  onItemPress: () => void;
  disabled?: boolean;
};

const TeamMemberItem = ({
  item,
  teamMember,
  onItemPress,
  disabled,
}: TeamMemberItemProps) => {
  const { accountData, teamMemberData } = useSelector(getAccountState).account;
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const isOwner = useMemo(
    () => item.uid === accountData.uid,
    [item.uid, accountData.uid]
  );

  return (
    <div className="AlignedRowSpaced" key={item.uid}>
      <ProfileItem
        profileItem={item.haveNotFinishedInitialStartup ? undefined : item}
        alternateTitle={
          item.haveNotFinishedInitialStartup
            ? "Pending Invitation"
            : teamMember?.fullName
        }
        subtext={
            <span className="smallBodySubtext">
              {isOwner ? item.email : teamMember?.email}
            </span>
          }
        onItemPress={onItemPress}
        hideViewIcon
        disabled={disabled || isOwner}
      />
      <div className="AlignedRow" style={{ gap: 14 }}>
        {teamMember || isOwner ? (
          <LabelButton
            text={
              (isOwner
                ? "Owner"
                : teamMember?.role === TeamMemberRole.FULL_ACCESS
                ? "Admin"
                : "Support") +
              (teamMemberData && teamMemberData.uid === teamMember?.uid
                ? " (You)"
                : "")
            }
            backgroundColor={Colors.WHITE1}
            color={Colors.BLACK}
            containerStyles={{
              border: `0.5px solid ${Colors.GRAY2}`,
            }}
          />
        ) : null}
        {teamMember && !disabled ? (
          <ManageTeamMemberDropdown
            teamMember={teamMember}
            item={item}
            isOpenDropdown={isOpenDropdown}
            setIsOpenDropdown={setIsOpenDropdown}
          >
            <ThreeDotsButton onPress={() => {}} />
          </ManageTeamMemberDropdown>
        ) : null}
      </div>
    </div>
  );
};

export default TeamMemberItem;
